import flatten from 'lodash/flatten'
import get from 'lodash/get'

export default {
  data() {
    return {
      selectedSegments: flatten(this.getArrayFromQuery('in[segment_ids]'))
    }
  },
  computed: {
    jobsPerPage() {
      return parseInt(this.$store.getters['jobsPerPage'])
    }
  },
  methods: {
    async pageChange(newPage) {
      this.refreshRoute({ ['page']: newPage })
    },
    onOrganisationChange(newOrganization) {
      const newQuery = {['in[organisation_id]']: newOrganization }
      this.refreshRoute(newQuery, true)
    },
    onSegmentsChange(newSegments) {
      this.selectedSegments = newSegments
      const newQuery = this.getSegmentsQuery(newSegments)
      this.refreshRoute(newQuery, true)
    },
    getSegmentsQuery(newSegments) {
      const segmentsIdsMap = new Map()

      newSegments.forEach(sId => {
        const groupId = get(this.$store.getters['getSegmentsById'][sId], 'segment_group_id')
        const groupIds = segmentsIdsMap.get(groupId) || []

        groupIds.push(sId)
        segmentsIdsMap.set(groupId, groupIds)
      })

      const groupedSegments = Array.from(segmentsIdsMap.values())
      const querySegments = groupedSegments.map(this.arrayToQuery)
      return { ['in[segment_ids]']: querySegments }
    }
  }
}
